export type ChartNodeNames = 'Critical' | 'High' | 'Medium';
export interface ChartPoint {
  x: number;
  y: number;
}
export interface RawDataItem {
  name: string;
  startValue: number;
  endValue: number;
  color: string;
}

export interface ChartNode extends ChartPoint {
  name: string;
  color: string;
  width: number;
  height: number;
  value: number;
  strokeWidth: number;
}

export enum ChartNodeType {
  Start = 'start',
  End = 'end',
}

export interface FunnelChartInfo {
  startNodes: ChartNode[];
  endNodes: ChartNode[];
  links: ChartLink[];
  totals: Record<ChartNodeType, number>;
}

export interface ChartLink {
  color: string;
  points: ChartPoint[];
}

export interface ChartOptions {
  link: {
    inlinePadding: number;
  };
  node: {
    width: number;
    minHeight?: number;
    blockPadding?: number;
  };
}
